import { usePreventContextMenu } from "@/hooks";
import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { forwardRef } from "react";

type TextAreaFieldProps = {
  error?: string;
  className?: string;
  title?: any;
  help?: any;
  caption?: string;
  required?: any;
  placeholder?: string;
  defaultValue?: string;
  disabled?: boolean;
  subTitle?: string;
  name?: string;
  visible?: boolean;
};
const TSTextAreaField = forwardRef<HTMLTextAreaElement, TextAreaFieldProps>(
  (props, ref) => {
    const [on, off] = usePreventContextMenu();

    const {
      error,
      className,
      title,
      help,
      caption,
      required,
      placeholder,
      defaultValue,
      disabled,
      subTitle,
      name,
      visible,
      ...textareaProps
    } = props;
    return (
      <div
        className={`${styles.inputField} ${styles.tsInputField} `}
        style={visible ? {} : { display: "none" }}
      >
        {title && (
          <legend
            className={classnames(`${styles.formTitle} ${styles.formTitleTS}`, {
              [styles.required]: required,
            })}
          >
            {subTitle}.{title}
          </legend>
        )}
        {help && (
          <span className={`${styles.help} ${styles.small}`}>{help}</span>
        )}
        <div className={styles.commentArea}>
          <textarea
            ref={ref}
            name={name}
            placeholder={placeholder}
            className={classnames(styles.textInput, className)}
            defaultValue={defaultValue}
            required={required}
            disabled={disabled}
            onFocus={off}
            onBlur={on}
            {...textareaProps}
          />
          {caption && <p className={styles.textInputCaption}>{caption}</p>}
        </div>
      </div>
    );
  }
);

TSTextAreaField.displayName = "TSTextAreaField";
export default TSTextAreaField;
